import { render, staticRenderFns } from "./MenuItemSubGroup.vue?vue&type=template&id=2a3e2192"
import script from "./MenuItemSubGroup.vue?vue&type=script&lang=js"
export * from "./MenuItemSubGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports